module.exports = __webpack_public_path__ + "static/media/feticcio.0648929b.gif";